export const PLAYER_RADIUS = 16
export const ARENA_HEIGHT = 500
export const ARENA_WIDTH = 500
export const DISTANCE_THRESHOLD_TRIGGER_PLANNER = 35 // 35 units of distance
